import { INTERNAL_PATH } from 'constants/path';

export const PROTECTED_LAYOUT_ROUTE_ID = 'protected-layout';

type RouteMatch = { id: string; pathname: string };

/** The matches under the protected layout, so a wrapper layout above it cannot shift positions. */
export function getMatchesBelowProtectedLayout<Match extends RouteMatch>(matches: Match[]) {
  const layoutIndex = matches.findIndex(({ id }) => id === PROTECTED_LAYOUT_ROUTE_ID);

  return layoutIndex === -1 ? [] : matches.slice(layoutIndex + 1);
}

/** CN internal pages (`/admin/*`) are the one route group that has no left nav or location bar. */
export function isInternalAdminPage(matches: RouteMatch[]) {
  return getMatchesBelowProtectedLayout(matches)[0]?.pathname === INTERNAL_PATH;
}
